// extracted by mini-css-extract-plugin
export var inline = "FixedImage-module--inline--hpuNV";
export var root = "FixedImage-module--root--gsHWh";
export var side = "FixedImage-module--side--QO-6+";